import { sizeTokenOptions, sizeTokenOptionsWithDefault, UI_FIELD_DEFAULT_OPTION, } from './token-options.js';
const dimensionOptions = (names) => sizeTokenOptions('dimension').filter((option) => names.includes(option.value));
export const INPUT_FIELDS = [
    {
        key: 'input.height',
        label: '입력칸 높이',
        help: '글자 입력칸·선택 칸(눌러서 고르는 칸)·검색창의 높이입니다. 입력칸 옆에 붙은 버튼(인증번호 받기 등)도 같은 높이가 됩니다. 기본은 지금 높이(앱 42px · 모바일 웹 48px)입니다.',
        group: '입력칸·선택 칸·검색창',
        type: 'enum',
        defaultValue: UI_FIELD_DEFAULT_OPTION,
        options: [
            { value: UI_FIELD_DEFAULT_OPTION, label: '기본 (앱 42px · 모바일 웹 48px)' },
            ...dimensionOptions(['l', 'l-plus', 'xl', 'xl-plus', '2xl']),
        ],
    },
    {
        key: 'input.radius',
        label: '입력칸 모서리 둥글기',
        help: '글자 입력칸·선택 칸·검색창 네 모서리의 둥글기입니다. 기본은 지금 모양(앱 7px · 모바일 웹 8px)입니다.',
        group: '입력칸·선택 칸·검색창',
        type: 'enum',
        defaultValue: UI_FIELD_DEFAULT_OPTION,
        options: sizeTokenOptionsWithDefault('radius', '앱 7px · 모바일 웹 8px'),
    },
    {
        key: 'input.paddingX',
        label: '입력칸 안쪽 좌우 여백',
        help: '입력칸·선택 칸·검색창 안에서 글자와 칸 끝 사이의 여백입니다. 글자 입력칸은 왼쪽 여백만 바뀝니다(오른쪽은 지우기 버튼·단위 자리). 기본은 지금 여백(앱 10.5px · 모바일 웹 12px)입니다.',
        group: '입력칸·선택 칸·검색창',
        type: 'enum',
        defaultValue: UI_FIELD_DEFAULT_OPTION,
        options: sizeTokenOptionsWithDefault('spacing', '앱 10.5px · 모바일 웹 12px'),
    },
    {
        key: 'input.fontSize',
        label: '입력칸 글자 크기',
        help: '글자 입력칸에 쓰는 글자와 선택 칸에 보이는 선택값의 크기입니다. 검색창은 바뀌지 않고, 채팅 입력칸은 따로 정합니다.',
        group: '입력칸·선택 칸·검색창',
        type: 'size',
        tokenGroup: 'fontSize',
        defaultValue: '$fontSize.sm',
        min: 10,
        max: 20,
    },
    {
        key: 'input.message.radius',
        label: '채팅 입력칸 모서리 둥글기',
        help: '채팅방·댓글처럼 메시지를 쓰는 입력칸 테두리의 둥글기입니다. 기본은 지금 모양(앱 21px · 모바일 웹 24px)입니다.',
        group: '채팅 입력칸',
        type: 'enum',
        defaultValue: UI_FIELD_DEFAULT_OPTION,
        options: sizeTokenOptionsWithDefault('radius', '앱 21px · 모바일 웹 24px'),
    },
    {
        key: 'input.message.fontSize',
        label: '채팅 입력칸 글자 크기',
        help: '메시지를 쓰는 입력칸의 글자 크기입니다.',
        group: '채팅 입력칸',
        type: 'size',
        tokenGroup: 'fontSize',
        defaultValue: '$fontSize.base',
        min: 12,
        max: 20,
    },
    {
        key: 'input.message.maxHeight',
        label: '채팅 입력칸 최대 높이',
        help: '메시지가 여러 줄일 때 입력칸이 늘어나는 최대 높이입니다. 넘치면 입력칸 안에서 스크롤됩니다.',
        group: '채팅 입력칸',
        type: 'size',
        tokenGroup: 'dimension',
        defaultValue: '$dimension.5xl',
        min: 48,
        max: 240,
    },
    {
        key: 'input.message.buttonSize',
        label: '채팅 입력칸 버튼 크기',
        help: '채팅 입력칸 양옆의 사진 추가(+)·보내기 버튼이 보이는 크기입니다. 누를 수 있는 영역은 48px 그대로입니다.',
        group: '채팅 입력칸',
        type: 'size',
        tokenGroup: 'dimension',
        defaultValue: '$dimension.l',
        min: 24,
        max: 48,
    },
    {
        key: 'input.checkbox.iconSize',
        label: '체크박스 크기',
        help: '글자 옆 체크박스(동의·선택 항목) 아이콘의 크기입니다.',
        group: '체크박스',
        type: 'size',
        tokenGroup: 'dimension',
        defaultValue: '$dimension.xs',
        min: 14,
        max: 32,
    },
];
//# sourceMappingURL=input.js.map